module.exports = __webpack_public_path__ + "static/media/access_top_talent.64085ecf.svg";